import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AuthVerifyTwoFactorLoginPayload } from 'api/actions/auth-verify-two-factor-login/auth-verify-two-factor-login-payload';
import { AuthVerifyTwoFactorLoginPathParameters } from 'api/actions/auth-verify-two-factor-login/auth-verify-two-factor-login-path-parameters';
import { AuthVerifyTwoFactorLoginResponse } from 'api/actions/auth-verify-two-factor-login/auth-verify-two-factor-login-response';

type AuthVerifyTwoFactorLoginQueryParameters = Record<string, any>;

/**
 * The path of the AuthVerifyTwoFactorLogin action.
 */
export const authVerifyTwoFactorLoginActionPath = new SweetPath<keyof AuthVerifyTwoFactorLoginPathParameters>(
  '/api/auth/two-factor/verify-login',
  { path: '{param}' }
);

/**
 * Creates a contextualized AuthVerifyTwoFactorLogin actions.
 */
export default function createAuthVerifyTwoFactorLoginAction(axios: AxiosInstance) {
  return function authVerifyTwoFactorLoginAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: AuthVerifyTwoFactorLoginQueryParameters;
    payload: AuthVerifyTwoFactorLoginPayload;
  }) {
    const path = authVerifyTwoFactorLoginActionPath.original;

    return axios.request<AuthVerifyTwoFactorLoginResponse, AuthVerifyTwoFactorLoginResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
